import { Heading, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import { templateSelector } from 'redux/modules/template-wizard/selectors';
import { templateRequiresFlowSelection } from '../utils';

const TemplateWizardGreeting: React.FC = () => {
  const template = useSelector(templateSelector);
  const showFlowSelector = templateRequiresFlowSelection(template);

  return (
    <Spacer align="center" orientation="vertical" space="8px">
      <Heading level={1} lineHeight={1.3}>
        {template.displayName}
      </Heading>
      <Heading level={2} letterSpacing="normal" lineHeight={1.3}>
        {showFlowSelector
          ? 'How would you like to use this template?'
          : "Great choice! Now, let's make it yours."}
      </Heading>
    </Spacer>
  );
};

export default TemplateWizardGreeting;
